import { Text } from '@mentimeter/ragnar-ui/text';
import { useRef } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { TextFitGhost } from '../components/text-fit-ghost/TextFitGhost';
import { AXIS_LABEL_PADDING, AXIS_LABEL_SIZE, FONT_SIZES } from './constants';

export const VerticalAxis = ({
  text,
  height,
}: {
  text: string;
  height: number;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={containerRef}
      width={AXIS_LABEL_SIZE}
      height={height}
      mr={AXIS_LABEL_PADDING}
      mb={AXIS_LABEL_SIZE + AXIS_LABEL_PADDING}
      alignSelf="center"
      justifyContent="center"
      style={{ opacity: 0 }}
    >
      <TextFitGhost
        text={text}
        fontSizes={FONT_SIZES}
        finalFontSizeContainerRef={containerRef}
        width={height}
        height={AXIS_LABEL_SIZE}
        // The ghost is made to work with horizontal text so the width and the height are swapped
        // width is set to "100%" in styles so the override is repeated here again
        style={{ position: 'absolute', width: height, top: 0, left: 0 }}
      >
        {(ref) => (
          <Text ref={ref} mr="space6" aria-hidden="true">
            {text} →
          </Text>
        )}
      </TextFitGhost>
      <Text fontSize="inherit" style={{ writingMode: 'sideways-lr' }}>
        {text} →
      </Text>
    </Box>
  );
};
